import { apiClient } from './client';

/**
 * Ontology share types
 */
export interface OntologyShareInfo {
  id: string;
  ontology_id: string;
  shared_with_email: string;
  shared_with_display_name: string | null;
  permission: string;
  created_at: string;
}

export interface SharedOntologyItem {
  id: string;
  name: string;
  description: string | null;
  /** User-typed save label, NOT a version number (migration 051). */
  save_label: string | null;
  created_at: string;
  updated_at: string;
  owner_email: string;
  owner_display_name: string | null;
  shared_at: string;
  /** Latest published version_number, or null if never published. */
  latest_published_version: string | null;
  /** Whether an editable draft exists at all. */
  has_draft: boolean;
  /**
   * The published number the current draft was forked from, or null if the
   * ontology has never been published. A draft itself has no number.
   */
  draft_parent_version: string | null;
  /** 'published' if at least one published version exists; otherwise 'draft'. */
  status: 'draft' | 'published';
}

/**
 * Share API endpoints
 */
export const shareApi = {
  /**
   * Share an ontology with a user by email
   */
  async shareOntology(
    ontologyId: string,
    email: string,
    permission: 'read' | 'write' = 'read'
  ): Promise<OntologyShareInfo> {
    return apiClient.post(`/api/ontologies/${ontologyId}/shares`, { email, permission });
  },

  /**
   * List all shares for an ontology (owner only)
   */
  async getShares(ontologyId: string): Promise<OntologyShareInfo[]> {
    return apiClient.get(`/api/ontologies/${ontologyId}/shares`);
  },

  /**
   * Revoke a share
   */
  async revokeShare(ontologyId: string, shareId: string): Promise<void> {
    return apiClient.delete(`/api/ontologies/${ontologyId}/shares/${shareId}`);
  },

  /**
   * Get ontologies shared with the current user
   */
  async getSharedWithMe(): Promise<SharedOntologyItem[]> {
    return apiClient.get('/api/ontologies/shared-with-me');
  },
};

// Made with Bob
